import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {RfqDataService} from '../service/rfq.data.service';
import {Area} from '../../@shared';

@Component({
    selector: 'app-rfq-step-one',
    templateUrl: './step-one.component.html',
    styleUrls: ['../rfq.component.scss', '../rfq.blocks.scss']
})
export class StepOneComponent implements OnInit {

    @Input('event$') event$: EventEmitter<boolean>;
    @Input('navigation$') navigation$: EventEmitter<boolean>;

    @ViewChild('stepOne') stepOneDivElement!: ElementRef<HTMLDivElement>;
    @ViewChild('navigation') navigation!: ElementRef<HTMLDivElement>;

    areas: any[] = [{label: 'Kitchen', usage: 0}];
    cols: any[] = [];

    constructor(@Inject(DOCUMENT) public document: Document,
                public data: RfqDataService) {
    }

    ngOnInit(): void {
        this.event$?.subscribe((event: boolean): void => {
            this.data.steps[0].height
                = this.navigation.nativeElement.scrollHeight + this.stepOneDivElement.nativeElement.scrollHeight;
        });
    }

    openSidebar(area: Area): void {
        this.data.area = area;
        this.data.sideBar.visible = true;
        this.data.sideBar.class = 'visible';
    }

    back(): void {
        this.navigation$.emit(false);
    }

    next(): void {
        this.navigation$.emit(true);
    }
}
